/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
	  constructor() {
			super();
			this.pageHeight = window.innerHeight;
	  }

		connectedCallback() {
			this.addEventListener('click', this.onClick);
            this.addEventListener('keydown', this.onKeyDown.bind(this));
			window.addEventListener('scroll', this.checkVisible.bind(this));
            this.setAttribute('tabindex', '0');
            this.setAttribute('aria-label', 'Back to top');
            this.setAttribute('role', 'button');
		}

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
		    if (y > this.pageHeight) {
		      this.classList.add('back-to-top--active');
		    } else {
					this.classList.remove('back-to-top--active');
				}
			});
	  }

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
	  }
      onKeyDown(event) {
			if (event.key === 'Enter' || event.key === ' ') {
				this.onClick();
			}
		}
	}
	customElements.define('back-to-top', BackToTop);
}
